import React from 'react';
import Link from 'next/link';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './errorPage.module.scss';
const cx = classnames.bind(styles);

const AlreadySavedResult = () => {
  return (
    <div className={cx('errorPageArea', 'overValidPeriod')}>
      <div className={cx('errorPageInner')}>
        <em className={cx('title')}>역검 결과 저장 가능한 유효기간이 초과하였습니다.</em>

        <Link href={RouteUrl.ACCA_TEST_GATE} legacyBehavior>
          <a className={cx('btn')} role="button">
            잡다로 이동하기
          </a>
        </Link>
      </div>
    </div>
  );
};

export default AlreadySavedResult;
